/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module enter
 */
export { default as Enter } from './enter.js';
export { default as ShiftEnter } from './shiftenter.js';
import './augmentation.js';
